export default __webpack_public_path__ + "static/media/wl-ico.d7217e94.svg";